// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Auth_root_3fxwp{width:350px;top:50%;left:50%;transform:translate(-50%,-55%)}.Auth_logo_3uTA0,.Auth_root_3fxwp{position:absolute}.Auth_logo_3uTA0{display:flex;align-items:center;justify-content:center;top:-82px;margin-left:24px}.Auth_logo_3uTA0 .Auth_icon_12ett{width:70px;margin-right:-2px;transform:translateY(-3px)}.Auth_logo_3uTA0 .Auth_text_1qg_F{color:#313a46;opacity:.7;font-weight:400;font-size:19px;white-space:nowrap;letter-spacing:.085em;margin-bottom:16px}.Auth_divider_1YLWV{display:flex;align-items:center;margin:20px 0}.Auth_divider_1YLWV:after,.Auth_divider_1YLWV:before{content:\"\";flex:1;height:1px;background:#e0e0e0}.Auth_divider_1YLWV span{padding:0 15px;color:#999;font-size:14px}.Auth_bg_30ifh{position:absolute;left:50%;top:50%;transform:translate(-50.5%,-50%)}", ""]);
// Exports
exports.locals = {
	"root": "Auth_root_3fxwp",
	"logo": "Auth_logo_3uTA0",
	"icon": "Auth_icon_12ett",
	"text": "Auth_text_1qg_F",
	"divider": "Auth_divider_1YLWV",
	"bg": "Auth_bg_30ifh"
};
module.exports = exports;
